import React, { useState } from "react";
import "./App.css";
import { useNavigate } from "react-router-dom";
import VideoJobForm from "./VideoJobForm";
import VideoPublishedTable from "./VideoPublishedTable";

// Dashboard layout matching the provided high-fidelity mockup description
const Dashboard = () => {
	const navigate = useNavigate();
	const [tableRefreshKey, setTableRefreshKey] = useState(0);
	const storedName = localStorage.getItem("cliperos_user_name");

	const handleLogout = () => {
		// Clear auth-related data
		localStorage.removeItem("cliperos_token");
		localStorage.removeItem("cliperos_user");
		localStorage.removeItem("cliperos_auth");

		// Redirect to login page
		navigate("/login");
	};

	return (
		<div className="dashboard-root">
			{/* Sidebar */}
			<aside className="dashboard-sidebar">
				{/* Branding */}
				<div className="sidebar-brand">
                    <div className="logo-play">
                      <div className="logo-play-triangle" />
                    </div>

					<span className="brand-text">Cliperos</span>
				</div>

				{/* Primary navigation */}
				<nav className="sidebar-nav">
					<button className="nav-item nav-item-active">
						<span className="nav-icon">🏠</span>
						<span>Início</span>
					</button>
					
				</nav>

				{/* Footer navigation */}
				<div className="sidebar-footer">
					<button className="nav-item" onClick={handleLogout}>
						<span className="nav-icon">⏏️</span>
						<span>Salir</span>
					</button>
				</div>
			</aside>

			{/* Main content area */}
			<main className="dashboard-main">
				{/* Header */}
				<header className="dashboard-header">
					<h1 className="page-title">Inicio</h1>
					<div className="header-actions">
						<button className="icon-button" aria-label="Notificações">
							<span>🔔</span>
						</button>
						<button className="avatar-button" aria-label="Perfil do usuário">
							<span className="avatar-circle">JM</span>
						</button>
					</div>
				</header>

				{/* Body */}
				<section className="dashboard-body">
					{/* Greeting card */}
					<div className="greeting-card">
						<p className="greeting-title">
							!Hola! <strong>{storedName || "Clipero"}</strong> 👋
						</p>
						<p className="greeting-quote">
							<em>
								Bienaventurados los pacificadores, porque ellos serán llamados Hijos
								de Dios.
							</em>
						</p>
					</div>

					{/* Core content: highlighted inline form inside black canvas */}
					<VideoJobForm onPublished={() => setTableRefreshKey((k) => k + 1)} />

					{/* Published videos table */}
                    <h1>Videos Publicados</h1>
					<VideoPublishedTable refreshKey={tableRefreshKey} />

					{/* Motivational text + CTA */}
					<div className="dashboard-cta">
						<p className="motivation-text">Tu próxima gran victoria está aqui!</p>
						
					</div>
				</section>
			</main>
		</div>
	);
};

export default Dashboard;

